interface CaptchaParams {
    sitekey: string;
}

export class ReCaptcha {
    private static DEFAULT_TOKEN = '93AOLTBLQQBHcvDUx21CA0Pxr65fJVX0e3XaU0D1h87c-3k4gfXv2WNYbhzPZ_K5xylmUGnMOZpOtCDB5m1mp8VbcHV9SQ-wtSvtaBs_VJ2toj6duOHhG397zsKgK1q5zqSQKQwhVziz7ZFUuxXfo0nNURuIom1j1GXvTtFXDDn7I6SilKV8DsOauJ5EX19EKUepdmqtuZ1TkmXWJtBkr2K6USRect1UIMe2sxqEPuMdy6O4L5Rf8kjnxQ16DH0pWNNj48e1rAdmXCmQ8vnhoaSbsZabqhRtdTLu-lifnwFfeA1ZI9hWnKYbOxh1oJsMn3o9flhdVemSgHr2J01mB74QGSysLDbjL74b7eR7X0EeM1yhmjFbVTu-2JJ9MjVkzjM345A5GnhndvhanObhipOIf0qecX8WeKdUOQ3BYOc5aqdw_yXsQislt';

    private static params: CaptchaParams = {
        sitekey: (process.env.NODE_ENV === 'production') ? '6LekpHoUAAAAACp6-6BRhHCWtaZGlolvggudrx6H' : '6LfZHLgUAAAAABD-l7E0rAKIlmxX_3R9pnBmZg-z'
    };

    static async execute(action: string, attempt: number = 8): Promise<string> {
        if (!!attempt && !window.recaptchaIsReady) {
            return await new Promise<string>(resolve => setTimeout(async () => {
                resolve(await ReCaptcha.execute(action, attempt - 1));
            }, 500));
        }

        if (!attempt) {
            return ReCaptcha.DEFAULT_TOKEN;
        }

        let res: string = '';
        try {
            res = await window.grecaptcha.execute(ReCaptcha.params.sitekey, { action });
        } catch (e) {
            res = ReCaptcha.DEFAULT_TOKEN;
        }
        return res;
    }
}
